import styled from 'styled-components';
import React from 'react';
import media from 'styles/media';
import { Label } from 'styles/elements/label';
import { ColumnDiv } from 'styles/elements/div';

const Container = styled(ColumnDiv)`
  flex: 1;
  margin-right: 20px;
  ${media.extraSmallAndBelow`
    margin-right: 8px;
  `}
`;

export const LabelledInput = ({ label, children }) => (
  <Container>
    <Label>
      {label}
    </Label>
    {children}
  </Container>
);
